import React from 'react';
import { connect } from 'react-redux';
import Header from './Header';
import Form from './Form';
import ChangePassword from './ChangePassword';
import Footer from './Footer';
import image from './background.jpg';
import '../../App.css';

const Login = props => {
  const {changePassword} = props

  return (
    <div style={{ ...styles.containerStyle, backgroundImage:`url(${image})`, backgroundRepeat:"no-repeat", backgroundSize:"cover" }}>
      <div style={styles.innerContainerStyle}>
        <Header />
        {changePassword ? <ChangePassword /> : <Form />}
        <Footer />
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  const {changePassword} = state.auth
  return {changePassword}
}
export default connect(mapStateToProps)(Login)

const styles = {
  containerStyle: {
    height: '100%',
    width: '100%',
    position: 'absolute',
    top: 0, 
    left: 0,
    backGroundColor: 'white',
    boxShadow: 'inset 0 0 10px #000000, inset 0 0 10px #000000'
  },
  innerContainerStyle: {
    width: '50%', 
    maxWidth: 500,
    height: 'auto', 
    backgroundColor: 'dodgerblue',
    borderRadius: 5,
    position: 'absolute',           
    top: '40%',                 
    transform: 'translate(0, -40%)',
    left: 0, 
    right: 0,
    margin: 'auto',
    boxShadow: '0 0 4px #000000, 0 0 20px #000000'
  }
}